import React from 'react'
import cx from 'classnames'
import IconButton from '@mui/material/IconButton'
import SortIconAsc from '@mui/icons-material/ArrowDownward'
import SortIconDes from '@mui/icons-material/ArrowUpward'
import { i18n } from '../index'
import css from './EmployeeTable.css'
import { UserType } from '../auth/types'
type EmployeeTableHeaderProps = {
  toggleSortColumn: (...args: Array<any>) => any
  toggleSortDirection: (...args: Array<any>) => any
  sortInfo: Array<{
    col: string
    direction: string
  }>
  isEditable: boolean
  userType: UserType
}

const EmployeeTableHeader = ({
  toggleSortColumn,
  toggleSortDirection,
  sortInfo,
  isEditable,
  userType,
}: EmployeeTableHeaderProps) => {
  const sortInfoName = sortInfo.find((info) => info.col === 'user.name')
  const sortInfoTime = sortInfo.find((info) => info.col === 'startTime')
  const sortInfoPosition = sortInfo.find((info) => info.col === 'position')
  const deniedRole = 'User'
  return (
    <thead className={css.tableHeader}>
      <tr>
        <th className={css.tableHeader}>
          <span className={css.thText} onClick={() => toggleSortColumn('user.name')}>
            {i18n.t('staffingPlan.name')}
          </span>
          {sortInfoName && (
            <IconButton onClick={() => toggleSortDirection('user.name')}>
              {sortInfoName.direction === 'ASC' ? (
                <SortIconAsc className={css.sortIcon} />
              ) : (
                <SortIconDes className={css.sortIcon} />
              )}
            </IconButton>
          )}
        </th>

        {!isEditable && <th className={css.tableHeader}>{i18n.t('staffingPlan.breaks')}</th>}

        <th className={css.timeColumn}>
          <span className={css.thText} onClick={() => toggleSortColumn('startTime')}>
            {i18n.t('staffingPlan.time')}
          </span>
          {sortInfoTime && (
            <IconButton onClick={() => toggleSortDirection('startTime')}>
              {sortInfoTime.direction === 'ASC' ? (
                <SortIconAsc className={css.sortIcon} />
              ) : (
                <SortIconDes className={css.sortIcon} />
              )}
            </IconButton>
          )}
        </th>

        <th className={css.alignLeftHeader}>
          <span className={css.thText} onClick={() => toggleSortColumn('position')}>
            {i18n.t('staffingPlan.position')}
          </span>
          {sortInfoPosition && (
            <IconButton onClick={() => toggleSortDirection('position')}>
              {sortInfoPosition.direction === 'ASC' ? (
                <SortIconAsc className={css.sortIcon} />
              ) : (
                <SortIconDes className={css.sortIcon} />
              )}
            </IconButton>
          )}
        </th>

        <th className={css.alignLeftHeader}>
          <span className={css.thText}>{i18n.t('staffingPlan.responsibility')}</span>
        </th>

        {userType !== deniedRole && (
          <th className={cx(css.alignRight, css.incentives)}>{i18n.t('staffingPlan.incentiveSales')}</th>
        )}
        {userType !== deniedRole && (
          <th className={cx(css.alignRight, css.incentives)}>{i18n.t('staffingPlan.thumbsUpServices')}</th>
        )}
        {isEditable && <th></th>}
      </tr>
    </thead>
  )
}

export default EmployeeTableHeader
